module.exports = __webpack_public_path__ + "img/bonvoy.fcc62246.png";